export const isOneYear = id => id >= 366 && id < 373;
